import { render, staticRenderFns } from "./StrukEdc.vue?vue&type=template&id=65fa1f90&scoped=true&"
import script from "./StrukEdc.vue?vue&type=script&lang=js&"
export * from "./StrukEdc.vue?vue&type=script&lang=js&"
import style0 from "./StrukEdc.vue?vue&type=style&index=0&id=65fa1f90&lang=scss&scoped=true&"
import style1 from "./StrukEdc.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fa1f90",
  null
  
)

export default component.exports